module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Men Gold + Cognac Closed.4d440a10.png";